import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import RadioButtons from '../radioButtons/radioButtons';
import classNames from 'classnames';
var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (_.isEmpty(props[propName]) === _.isEmpty(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }
  var optionsType = {
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
      disabled: PropTypes.bool
    }))])
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};
var ButtonsGroup = /*#__PURE__*/function (_React$Component) {
  function ButtonsGroup(props) {
    var _this;
    _classCallCheck(this, ButtonsGroup);
    _this = _callSuper(this, ButtonsGroup, [props]);
    _this.pickProps = function () {
      return _.pick(_this.props, ['value', 'onChange', 'options', 'disabled', 'shouldTranslate']);
    };
    return _this;
  }
  _inherits(ButtonsGroup, _React$Component);
  return _createClass(ButtonsGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(this.props.getClassName('control-buttons-list-group'), {
          disabled: this.props.disabled
        }),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(RadioButtons, _.assign({}, {
        orientation: 'horizontal',
        showRadioSymbol: false
      }, this.pickProps()), this.props.children));
    }
  }]);
}(React.Component);
ButtonsGroup.displayName = 'ButtonsGroup';
ButtonsGroup.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The currently selected button (should equal one of the `value` properties of an item in `options` list in case it is provided) */
  value: PropTypes.string,
  /** Invoked on selecting one of the buttons. Parameter: `value` - the value of the selected button {string} */
  onChange: PropTypes.func.isRequired,
  /** Either list of strings that would be used for both labels and values of each button, or a list of objects that each describes: <ul>
   *   <li><code>value</code> - the value assigned to the button {string}</li>
   *   <li><code>label</code> - the label on the button (optional) {string}</li>
   *   <li><code>disabled</code> - set to `true` to make button non-selectable (optional) {boolean}</li>
   * </ul>
   * <p>Note: exactly one of <code>options</code> or <code>children</code> props should be provided</p>
   * */
  options: validateOptions,
  /** When set to true, can not be changed and applies disabled styles */
  disabled: PropTypes.bool
};
ButtonsGroup.defaultProps = {
  disabled: false
};
export default compose(ButtonsGroup);